import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';

export const supportedLocales: readonly string[] = [
  Locale.en,
  Locale.en_IE,
  Locale.en_GB,
  Locale.de_CH,
  Locale.de_DE,
  Locale.de_AT,
  Locale.es_ES,
  Locale.fr_FR,
  Locale.fr_CH,
  Locale.it_IT,
  Locale.it_CH,
  Locale.pl_PL,
  Locale.sv_SE,
  Locale.no_NO,
  Locale.nl_NL,
  Locale.fr_LU,
  Locale.en_NZ,
  Locale.en_ZA,
];
